import { LibraryStore } from '@stores/Library/Library';

/**
 * What removing a library does for the current user. `DELETE /library/:id` detaches the library
 * from the caller's account and deletes it with its media only once no user is left on it, so
 * on somebody else's library the same call is a `detach` that leaves the owner's media alone.
 *
 * `unknown` ownership reads as `delete`: the stronger warning and the typed confirmation are the
 * safe side to be wrong on.
 */
export type LibraryRemoval = 'delete' | 'detach';

export const libraryRemovalFor = (library: LibraryStore | undefined): LibraryRemoval =>
  library?.isOwnedByAnotherUser ? 'detach' : 'delete';

/** The subject of "… in this library will be removed", for an optional media count. */
export const libraryMediaPhrase = (mediaCount: number | undefined) => {
  if (!mediaCount) return 'All media';
  return mediaCount === 1 ? 'The one media item' : `All ${mediaCount} media items`;
};
